import React from 'react';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import { MdEmail, MdLocationOn, MdLocalPhone, MdChevronRight } from 'react-icons/md';
import {
    FooterSection,
    FooterWrap,
    FooterLogo,
    Col,
    Img,
    ContactInfo,
    FooterLink,
    FooterMenu,
    SocialIcon,
    ScocialLink,
    CopySection
} from '../Footer/FooterElement';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <FooterSection>
            <FooterWrap>
                <Col>
                    <h3 style={{ marginBottom: '2rem' }}>Contact Info</h3>
                    <ContactInfo>
                        <span><MdLocationOn />Yllästunturintie 3 H 73, 00970 Helsinki</span>
                        <span>Y-tunnus 3205905-8</span>
                        <span><MdLocalPhone />+358-0415736253</span>
                        <span><MdEmail />prorenovasuomi@gmail.com</span>
                    </ContactInfo>
                    <SocialIcon>
                        <ScocialLink href='https://www.facebook.com/ProRenovaGroup' target="_blank" rel="noopener noreferrer"><FaFacebookF /></ScocialLink>
                        <ScocialLink href='https://www.instagram.com/prorenovasuomi/' target="_blank" rel="noopener noreferrer"><FaInstagram /></ScocialLink>
                    </SocialIcon>
                </Col>

                <Col style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <FooterLogo to='/'>
                        <Img src='/images/Logo.png' alt="Prorenova Logo" style={{ width: '80px', marginBottom: '10px' }} />
                        <h2 style={{ color: '#fff', fontSize: '3rem', fontWeight: 'bold', margin: '0' }}>Prorenova</h2>
                    </FooterLogo>
                </Col>

                <Col style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    <h3 style={{ marginBottom: '2rem' }}>Quick Links</h3>
                    <FooterMenu>
                        <FooterLink to='/' onClick={() => window.scrollTo(0, 0)}><MdChevronRight />Home</FooterLink>
                        <FooterLink to='/services' onClick={() => window.scrollTo(0, 0)}><MdChevronRight />Services</FooterLink>
                        <FooterLink to='/about' onClick={() => window.scrollTo(0, 0)}><MdChevronRight />About</FooterLink>
                        <FooterLink to='/contact' onClick={() => window.scrollTo(0, 0)}><MdChevronRight />Contact</FooterLink>
                    </FooterMenu>
                </Col>
            </FooterWrap>

            <CopySection style={{ borderTop: '1px solid rgba(255,255,255,0.1)', marginTop: '3rem', paddingTop: '2rem' }}>
                <p style={{ color: '#bbb', fontSize: '1.4rem', margin: 0, lineHeight: '1.5' }}>
                    © {currentYear} Prorenova. All Rights Reserved.<br/>
                    Developed by Dgtech
                </p>
            </CopySection>
        </FooterSection>
    )
}

export default Footer;
